// API Types - Generated from Symfony Backend

export interface UserPhotoView {
  id: number;
  originalUrl: string;
  thumbnailUrl: string;
  mediumUrl: string;
  largeUrl: string;
  thumbnailBlurUrl: string;
  mediumBlurUrl: string;
  largeBlurUrl: string;
  isDefault: boolean;
  isLocked: boolean;
}

export interface UserProfileView {
  id: string;
  email: string;
  nickName: string | null;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  bio: string | null;
  dateOfBirth: string | null;
  genderId: number | null;
  genderPreferenceIds: number[];
  hobbyIds: number[];
  cityIds: number[];
  photos: UserPhotoView[];
  defaultPhotoId: number | null;
  ratingAverage: number;
  ratingCount: number;
  isVerified: boolean;
  verifiedAt: string | null;
  otherCity: any[] | null;
}

export interface UserPublicProfileView {
  id: string;
  nickName: string | null;
  bio: string | null;
  genderId: number | null;
  hobbyIds: number[];
  photos: UserPhotoView[];
  defaultPhotoId: number | null;
  ratingAverage: number;
  ratingCount: number;
  dateOfBirth: string | null;
  age: number | null;
  isVerified: boolean;
  verifiedAt: string | null;
}

export interface UserRegistrationView {
  id: string;
  email: string;
}

export interface UserRegistrationInput {
  email: string;
  password: string;
  nickName: string;
  dateOfBirth?: string | null;
}

export interface UserProfileInput {
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
  bio?: string | null;
  dateOfBirth?: string | null;
  genderId?: number | null;
  genderPreferenceIds?: number[] | null;
  hobbyIds?: number[] | null;
  cityIds?: number[] | null;
  otherCity?: OtherCityData | null;
}

export interface UserPhotoUploadInput {
  base64Data: string;
  originalName?: string | null;
  mimeType?: string | null;
  isDefault?: boolean | null;
}

export interface UserPhotoSetDefaultInput {
  isDefault: boolean;
}

export interface UserPhoneVerificationRequestInput {
  userId: string;
  phoneNumber: string;
}

export interface UserPhoneVerificationConfirmInput {
  userId: string;
  code: string;
}

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export interface PasswordResetRequestInput {
  email?: string | null;
  phoneNumber?: string | null;
}

export interface PasswordResetConfirmInput {
  token: string;
  newPassword: string;
}

export interface MeetingAnnouncementLocationData {
  country: string | null;
  region: string | null;
  city: string | null;
  latitude: number | null;
  longitude: number | null;
}

export interface MeetingAnnouncementView {
  id: string;
  createdById: string;
  meetingTypeId: number;
  meetingDate: string;
  meetingTime: string;
  meetingAddress: string;
  locationData: MeetingAnnouncementLocationData | null;
  additionalInfo: string | null;
  createdByNickname: string | null;
  createdByFirstName: string | null;
  createdByLastName: string | null;
  createdByPhotoThumbnail: string | null;
  ageFrom: number | null;
  ageTo: number | null;
  durationHoursFrom: number | null;
  durationHoursTo: number | null;
  participantCount: number;
  paymentAmount: string | null;
  interestedGenderIds: number[];
  coversAllCosts: boolean;
  statusId: number | null;
  statusCode: string | null;
  hasApplied: boolean;
  photos?: MeetingAnnouncementPhotoView[];
}

export interface MeetingAnnouncementInput {
  meetingTypeId: number;
  meetingDate: string;
  meetingTime: string;
  meetingAddress: string;
  locationData?: any | null;
  additionalInfo?: string | null;
  ageFrom?: number | null;
  ageTo?: number | null;
  durationHoursFrom?: number | null;
  durationHoursTo?: number | null;
  participantCount?: number | null;
  paymentAmount?: number | null;
  interestedGenderIds?: number[] | null;
  coversAllCosts?: boolean | null;
}

export interface MeetingAnnouncementStatusUpdateInput {
  statusCode: string;
}

export interface MeetingAnnouncementSearchParams {
  country?: string;
  region?: string;
  city?: string;
  date_from?: string;
  date_to?: string;
  time_from?: string;
  time_to?: string;
  age_from?: number;
  age_to?: number;
  covers_all_costs?: boolean;
  payment_min?: number;
  payment_max?: number;
  gender_ids?: number[];
  nickname?: string;
  status_code?: string;
  owned_only?: boolean;
  sort?: 'date' | 'created' | 'payment';
  direction?: 'ASC' | 'DESC';
}

export interface MeetingAnnouncementPhotoView {
  id: number;
  downloadUrl: string;
  originalName: string | null;
  mimeType: string | null;
  size: number | null;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface MeetingAnnouncementPhotoUploadInput {
  file: File;
  isDefault?: boolean | null;
}

export interface MeetingAnnouncementPhotoFromPredefinedInput {
  predefinedImageId: number;
  isDefault?: boolean | null;
}

export interface MeetingAnnouncementPhotoSetDefaultInput {
  isDefault: boolean;
}

export interface MeetingAnnouncementApplicationView {
  id: string;
  meetingAnnouncementId: string;
  applicantId: string;
  applicantNickname: string | null;
  statusId: number | null;
  statusCode: string | null;
  motivation: string;
  proposedAmount: string | null;
  createdAt: string;
  updatedAt: string;
  applicantConfirmed: boolean;
  hostConfirmed: boolean;
}

export interface MeetingAnnouncementApplicationInput {
  motivation: string;
  proposedAmount?: number | null;
}

export interface MeetingAnnouncementApplicationStatusUpdateInput {
  statusCode: string;
  note?: string | null;
}

export interface MeetingAnnouncementApplicationConfirmInput {
  confirm?: boolean;
}

export interface GenderView {
  id: number;
  name: string | null;
}

export interface HobbyView {
  id: number;
  name: string | null;
}

export interface HobbyInput {
  translations: Array<{
    locale: string;
    name: string;
  }>;
}

export interface PredefinedAnnouncementImageView {
  id: number;
  code: string;
  label: string;
  previewUrl: string;
}

// User Rating Types
export interface UserRatingInput {
  score: number; // 1-5
}

export interface UserRatingView {
  id: string;
  revieweeId: string;
  reviewerId: string;
  score: number;
  revieweeAverage: number;
  revieweeRatingCount: number;
  createdAt: string;
}

// Meeting Type
export interface MeetingTypeView {
  id: number;
  name: string | null;
}

// Location Types
export interface CityView {
  id: number;
  name: string;
  regionId?: number | null;
  countryId: number;
}

export interface OtherCityData {
  lat: string;
  lon: string;
  displayName: string;
  city: string | null;
  region: string | null;
  state: string | null;
  country: string | null;
}

export interface CountryView {
  id: number;
  name: string;
}

export interface RegionView {
  id: number;
  name: string;
  countryId?: number | null;
}

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface AuthTokens {
  token: string;
  refreshToken?: string;
}

export interface ApiError {
  message: string;
  code?: string;
  violations?: Array<{
    propertyPath: string;
    message: string;
  }>;
  // API Platform ConstraintViolation fields
  '@context'?: string;
  '@type'?: string;
  '@id'?: string;
  description?: string;
  detail?: string;
  title?: string;
  status?: number;
  type?: string;
}

export interface PaginatedResponse<T> {
  'hydra:member': T[];
  'hydra:totalItems': number;
  'hydra:view'?: {
    'hydra:first'?: string;
    'hydra:last'?: string;
    'hydra:next'?: string;
    'hydra:previous'?: string;
  };
}

/**
 * API Platform collection response format
 * Handles both 'hydra:member' (legacy) and 'member' (current) formats
 */
export interface ApiPlatformCollectionResponse<T> {
  '@context'?: string;
  '@id'?: string;
  '@type'?: string;
  totalItems?: number;
  member: T[];
  // Legacy Hydra format support
  'hydra:member'?: T[];
  'hydra:totalItems'?: number;
  'hydra:view'?: {
    'hydra:first'?: string;
    'hydra:last'?: string;
    'hydra:next'?: string;
    'hydra:previous'?: string;
  };
}

/**
 * Extract array from API Platform collection response
 * Handles both 'member' and 'hydra:member' formats
 */
export function extractCollectionItems<T>(
  response: ApiPlatformCollectionResponse<T> | T[],
): T[] {
  // If response is already an array, return it
  if (Array.isArray(response)) {
    return response;
  }

  // Try 'member' first (current format), then 'hydra:member' (legacy), then empty array
  return response.member || response['hydra:member'] || [];
}

// Meeting Announcement Chat Types
export type MeetingAnnouncementChatStatus =
  | 'new'
  | 'in_progress'
  | 'finished'
  | 'banned';

export interface MeetingAnnouncementChatView {
  id: string;
  firebaseChatId: string;
  meetingAnnouncementId: string;
  hostId: string;
  applicantId: string;
  meetingAnnouncementApplicationId: string;
  status: MeetingAnnouncementChatStatus;
  createdAt: string;
  updatedAt: string;
}

export interface MeetingAnnouncementChatInput {
  firebaseChatId: string;
  meetingAnnouncementApplicationId: string;
}

export interface MeetingAnnouncementChatUpdateInput {
  firebaseChatId?: string;
  status?: 'new' | 'in_progress' | 'finished';
}

// User Deletion Request
export interface UserDeletionRequestInput {
  reason?: string | null;
}
